export default {
	liza: '/images/clients/liza/camp_liza_logotip_final.svg',
	ptoni: '/images/clients/ptoni/logo.png',
	ptoni_test: '/images/clients/ptoni_test/logo.png',
	ktoni: '/images/clients/ktoni/logo.png',
	ktoni_test: '/images/clients/ktoni_test/logo.png',
	test: '/images/clients/ktoni/logo.png',
};
